import React, { useState } from 'react';
import { createSubnetListCollection } from '../services/subnetListService';
import { Loader, Database, CheckCircle, AlertTriangle } from 'lucide-react';

export function AdminPanel() {
  const [isCreating, setIsCreating] = useState(false);
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleCreateSubnetList = async () => {
    try {
      setIsCreating(true);
      setStatus('idle');
      setMessage('Creating subnet list collection...');
      
      await createSubnetListCollection();
      
      setStatus('success');
      setMessage('Subnet list collection created successfully!');
    } catch (error) {
      console.error('Error creating subnet list:', error);
      setStatus('error');
      setMessage(error instanceof Error ? error.message : 'An unknown error occurred');
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <div className="bg-black/40 backdrop-blur-sm rounded-xl shadow-2xl p-4 md:p-8 border border-white/10">
      <div className="flex items-center space-x-3 mb-6">
        <Database className="w-8 h-8 text-red-600" />
        <h1 className="text-2xl md:text-3xl font-bold">Admin Panel</h1>
      </div>

      <div className="space-y-6">
        <div className="bg-black/20 backdrop-blur-sm rounded-lg p-6 border border-white/5">
          <h2 className="text-xl font-bold mb-4">Database Management</h2>
          
          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-semibold mb-2">Subnet List Collection</h3>
              <p className="text-gray-300 mb-4">
                Create or update the subnet_list collection with information from all subnets including descriptions, GitHub links, and X links.
              </p>
              
              <button
                onClick={handleCreateSubnetList}
                disabled={isCreating}
                className={`px-4 py-2 rounded-lg flex items-center space-x-2 ${
                  isCreating 
                    ? 'bg-gray-600 cursor-not-allowed' 
                    : 'bg-red-600 hover:bg-red-700'
                }`}
              >
                {isCreating ? (
                  <Loader className="w-5 h-5 animate-spin" />
                ) : (
                  <Database className="w-5 h-5" />
                )}
                <span>{isCreating ? 'Creating...' : 'Create Subnet List'}</span>
              </button>
              
              {status !== 'idle' && (
                <div className={`mt-4 p-3 rounded-lg flex items-start space-x-2 ${
                  status === 'success' ? 'bg-green-900/30 text-green-400' : 'bg-red-900/30 text-red-400'
                }`}>
                  {status === 'success' ? (
                    <CheckCircle className="w-5 h-5 mt-0.5 flex-shrink-0" />
                  ) : (
                    <AlertTriangle className="w-5 h-5 mt-0.5 flex-shrink-0" />
                  )}
                  <span>{message}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}